function ready(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
    return;
  }

  callback();
}

function mobile() {
  return window.isMobile || window.innerWidth <= 768;
}

function tablet() {
  return window.isTablet || window.innerWidth <= 1024;
}

function toRem(value) {
  return value / 16 + 'rem';
}

ready(function () {
  let root = document.querySelector('.section--babylon-wrap');

  initHero(root);
  initVideo(root);
  initCraft(root);
  
  ScrollTrigger.refresh(true);
});

function initHero(root) {
  let section = root.querySelector('.section--babylon');
  if (!section) {
    return;
  }

  let positions = [
    { from: 260, to: -220 },
    { from: 520, to: -320 },
    { from: 360, to: -300 },
    { from: 440, to: -280 },
    { from: 620, to: -360 },
    { from: 760, to: -420 },
    { from: 520, to: -280 },
    { from: 300, to: -220 },
    { from: 520, to: -340 },
    { from: 420, to: -260 },
    { from: 620, to: -380 },
    { from: 220, to: -180 },
    { from: 360, to: -220 },
    { from: 260, to: -200 },
    { from: 440, to: -300 },
    { from: 320, to: -260 },
    { from: 700, to: -420 }
  ];

  root.querySelectorAll('.babylon__img').forEach(function (item, index) {
    let position = positions[index] || { from: 200, to: -200 };
    let from = position.from;
    let to = position.to;

    if (mobile()) {
      from = from / 1.7;
      to = to / 1.4;
    } else if (tablet()) {
      to = to;
    }

    gsap.fromTo(item, {
      y: toRem(from)
    }, {
      y: toRem(to),
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: tablet() ? 'top 150%' : 'top bottom',
        end: tablet() ? '+=2000' : '+=1600',
        scrub: true,
        // markers: true,
      }
    });
  });

  let flying = root.querySelector('.babylon__flying');
  if (flying) {
    gsap.fromTo(flying, {
      y: mobile() ? 80 : 180
    }, {
      y: mobile() ? -80 : -220,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: '+=1500',
        scrub: true
      }
    });
  }

  root.querySelectorAll('.babylon__bg--1').forEach(function (bg, index) {
    gsap.fromTo(bg, {
      y:  mobile() ? 70 : 200
    }, {
      y: mobile() ? -250 : -260,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: mobile() ? 'top 15%' : 'top bottom',
        end: '+=1500',
        scrub: true,
      }
    });
  });


  root.querySelectorAll('.babylon__bg--2').forEach(function (bg, index) {
    gsap.fromTo(bg, {
      y: 0
    }, {
      y: mobile() ? -100 : -160,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: mobile() ? 'top 15%' : 'top bottom',
        end: '+=2000',
        scrub: true,
      }
    });
  });

  gsap.fromTo(section.querySelectorAll('.babylon__title, .text'), {
    y: 20
  }, {
    y: mobile() ? -150 : -150,
    ease: 'none',
    scrollTrigger: {
      trigger: section,
      start: 'top bottom',
      end: '+=1500',
      scrub: true
    }
  });


  gsap.fromTo(root.querySelectorAll('.babylon__title-bg'), {
    y: 100
  }, {
    y: mobile() ? -50 : -100,
    ease: 'none',
    scrollTrigger: {
      trigger: '.babylon-info .babylon__title',
      start: 'top bottom',
      end: '+=1000',
      scrub: true
    }
  });
}

function initVideo(root) {
  root.querySelectorAll('.video-product').forEach(function (video) {
    let section = video.closest('.section--video-product');
    if (!section) {
      return;
    }

    gsap.fromTo(video, {
      scale: 1.1
    }, {
      scale: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: '+=1000',
        scrub: true
      }
    });
  });
}

function initCraft(root) {
  if (tablet()) {
    return;
  }

  root.querySelectorAll('.craft-item:not(.craft-item--static)').forEach(function (item) {
    let content = item.querySelector('.craft-item__content');
    let image = item.querySelector('.craft-item__img');

    gsap.fromTo(content, {
      y: '300%'
    }, {
      y: '-50%',
      ease: 'none',
      scrollTrigger: {
        trigger: item,
        start: 'top bottom',
        end: '+=2000',
        scrub: true
      }
    });

    gsap.fromTo(image, {
      y: '30%'
    }, {
      y: '-15%',
      ease: 'none',
      scrollTrigger: {
        trigger: item,
        start: 'top bottom',
        end: '+=2000',
        scrub: true
      }
    });
  });


  root.querySelectorAll('.babylon-info__item').forEach( (item, index) => {
    let content = item.querySelector('.babylon-info__item-texts');

    gsap.fromTo(content, {
      y:  150
    }, {
      y: -150,
      ease: 'none',
      scrollTrigger: {
        trigger: item,
        start: 'top bottom',
        end: '+=1500',
        scrub: true
      }
    });
  });
}